// The strike flight arc (docs/ART-DIRECTION.md §7 Flight), shared by a missile's glyph (render/units/GlyphLayer.ts)
// and its ribbon (vfx/FlightSystem.ts), so the ribbon always meets the glyph. A missile flies from its launch city
// toward where it is headed — its homing target's position now, so a moving target bends its course — and its arc
// spans the whole flight: the part flown (launch → here) plus the part left (here → target). It rises
// STRIKE_ARC_APEX_PER_RAD per radian of that whole flight, highest halfway.

import type { Vector3 } from 'three'
import { STRIKE_ARC_APEX_PER_RAD } from './globeSpace'

/** Height of the flight arc above the network at `progress` along a flight of `angle` radians. */
export function flightLift(angle: number, progress: number): number {
  return STRIKE_ARC_APEX_PER_RAD * angle * Math.sin(Math.PI * progress)
}

export interface StrikeArcOut {
  /** Radians flown (launch → here) and left (here → target). */
  flown: number
  left: number
  /** The flown share of the whole flight, 0–1. */
  progress: number
}

/** Where a missile at unit normal `here` is on its flight from `origin` toward `target` (unit normals). */
export function strikeArcAt(origin: Vector3, here: Vector3, target: Vector3, out: StrikeArcOut): StrikeArcOut {
  out.flown = origin.angleTo(here)
  out.left = here.angleTo(target)
  const whole = out.flown + out.left
  out.progress = whole > 0 ? out.flown / whole : 1
  return out
}
